import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'menu',
      type: 'select',
      label: '菜单名称',
      filterable: true,
      clearable: true,
      placeholder: '请输入菜单名称',
      otherOptions: {
        changeField: 'module',
        changeUrl: '/main/oprHistory/queryModule',
        params: [{key: 'menu', field: 'menu'}]
      }
    },
    {
      field: 'module',
      type: 'select',
      label: '模块名称',
      filterable: true,
      clearable: true,
      placeholder: '请输入模块名称',
      otherOptions: {
        changeField: 'func',
        changeUrl: '/main/oprHistory/queryFunc',
        params: [{key: 'menu', field: 'menu'}, {key: 'module', field: 'module'}]
      }
    },
    {
      field: 'func',
      type: 'select',
      label: '功能名称',
      filterable: true,
      clearable: true,
      placeholder: '请输入功能名称'
    },
    {
      field: 'userid',
      type: 'select',
      label: '使用人',
      filterable: true,
      clearable: true,
      placeholder: '请输入使用人'
    },
    {
      field: 'timeSlot',
      type: 'datepicker',
      label: '筛选日期',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          const sixMonthsAgo = new Date();
          sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
          return date.getTime() < sixMonthsAgo.getTime();
        }
      }
    }
  ]
}
